import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AhmedElshahatJobService {

  constructor(private http: HttpClient) { }

  // =========================
  // Jobs
  // =========================

  getJobs(filters: any = {}): Observable<any> {
    let params = new HttpParams();

    Object.keys(filters).forEach(key => {
      if (
        filters[key] !== null &&
        filters[key] !== undefined &&
        filters[key] !== ''
      ) {
        params = params.set(key, filters[key]);
      }
    });

    return this.http.get(`${environment.Server_URL}/ahmed-elshahat-jobs`, { params });
  }

  getJob(id: any): Observable<any> {
    return this.http.get(`${environment.Server_URL}/ahmed-elshahat-jobs/${id}`);
  }

  addJob(data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/ahmed-elshahat-jobs`, data);
  }

  updateJob(id: any, data: any): Observable<any> {
    return this.http.put(`${environment.Server_URL}/ahmed-elshahat-jobs/${id}`, data);
  }

  deleteJob(id: any): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/ahmed-elshahat-jobs/${id}`);
  }

  increaseViews(id: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/ahmed-elshahat-jobs/${id}/increase-views`, {});
  }

  // =========================
  // Skills
  // =========================

  getSkills(filters: any = {}): Observable<any> {
    let params = new HttpParams();

    Object.keys(filters).forEach(key => {
      if (
        filters[key] !== null &&
        filters[key] !== undefined &&
        filters[key] !== ''
      ) {
        params = params.set(key, filters[key]);
      }
    });

    return this.http.get(`${environment.Server_URL}/skills`, { params });
  }

  getAllSkills(): Observable<any> {
    const params = new HttpParams().set('per_page', '1000');
    return this.http.get(`${environment.Server_URL}/skills`, { params });
  }

  getSkill(id: any): Observable<any> {
    return this.http.get(`${environment.Server_URL}/skills/${id}`);
  }

  addSkill(data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/skills`, data);
  }

  updateSkill(id: any, data: any): Observable<any> {
    return this.http.put(`${environment.Server_URL}/skills/${id}`, data);
  }

  deleteSkill(id: any): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/skills/${id}`);
  }

  // =========================
  // Job Requirements
  // =========================

  getJobRequirements(filters: any = {}): Observable<any> {
    let params = new HttpParams();

    Object.keys(filters).forEach(key => {
      if (
        filters[key] !== null &&
        filters[key] !== undefined &&
        filters[key] !== ''
      ) {
        params = params.set(key, filters[key]);
      }
    });

    return this.http.get(`${environment.Server_URL}/job-requirements`, { params });
  }

  getJobRequirement(id: any): Observable<any> {
    return this.http.get(`${environment.Server_URL}/job-requirements/${id}`);
  }

  addJobRequirement(data: any): Observable<any> {
    return this.http.post(`${environment.Server_URL}/job-requirements`, data);
  }

  updateJobRequirement(id: any, data: any): Observable<any> {
    return this.http.put(`${environment.Server_URL}/job-requirements/${id}`, data);
  }

  deleteJobRequirement(id: any): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/job-requirements/${id}`);
  }

  // =========================
  // Helpers For Admin Form
  // =========================

  getJobsByStatus(status: string, page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('status', status)
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/ahmed-elshahat-jobs`, { params });
  }

  searchJobs(keyword: string, page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('search', keyword)
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/ahmed-elshahat-jobs`, { params });
  }

  getJobRequirementsByJobId(jobId: any): Observable<any> {
    const params = new HttpParams().set('job_id', jobId);

    return this.http.get(`${environment.Server_URL}/job-requirements`, { params });
  }
}